__turbopack_context__.v({
  "actions": "index-module-scss-module__Bdro3q__actions",
  "ant-dropdown-menu": "index-module-scss-module__Bdro3q__ant-dropdown-menu",
  "ant-dropdown-menu-item": "index-module-scss-module__Bdro3q__ant-dropdown-menu-item",
  "ant-dropdown-menu-item-selected": "index-module-scss-module__Bdro3q__ant-dropdown-menu-item-selected",
  "ant-dropdown-menu-title-content": "index-module-scss-module__Bdro3q__ant-dropdown-menu-title-content",
  "back-top-wrap": "index-module-scss-module__Bdro3q__back-top-wrap",
  "brand": "index-module-scss-module__Bdro3q__brand",
  "brandName": "index-module-scss-module__Bdro3q__brandName",
  "closeButton": "index-module-scss-module__Bdro3q__closeButton",
  "drawer": "index-module-scss-module__Bdro3q__drawer",
  "entryButton": "index-module-scss-module__Bdro3q__entryButton",
  "entryButtonCollapsed": "index-module-scss-module__Bdro3q__entryButtonCollapsed",
  "entryButtonText": "index-module-scss-module__Bdro3q__entryButtonText",
  "entryIcon": "index-module-scss-module__Bdro3q__entryIcon",
  "filterTableSelect": "index-module-scss-module__Bdro3q__filterTableSelect",
  "fixedEntry": "index-module-scss-module__Bdro3q__fixedEntry",
  "header": "index-module-scss-module__Bdro3q__header",
  "iconAction": "index-module-scss-module__Bdro3q__iconAction",
  "iframe": "index-module-scss-module__Bdro3q__iframe",
  "mobileDrawer": "index-module-scss-module__Bdro3q__mobileDrawer",
});
